// extracted by mini-css-extract-plugin
export default {"wrapper":"Bt-z","response":"Ct-z","error":"Dt-z","disabled":"Et-z","buttons":"Ft-z","feedbackQuestionSection":"Gt-z","yesNoWrapper":"Ht-z"};